import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { swSettings } from "app/common/services/swSettings";
import { Footer } from "app/components/no-touch-purchase-modal/summary-modal/details/footer/Footer";
import { OrderSummary } from "app/components/no-touch-purchase-modal/summary-modal/details/order-summary/OrderSummary";
import { useNoTouchPurchaseSummaryModalDetails } from "app/components/no-touch-purchase-modal/summary-modal/details/useNoTouchPurchaseSummaryModalDetails";
import type { INoTouchAddon } from "app/components/no-touch-purchase-modal/summary-modal/useNoTouchPurchaseSummaryModal";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";
import type { AddonTypeName } from "app/contexts/AddonStateContext/const";
import { Divider } from "app/pages/market-research/components/Divider";

interface INoTouchPurchaseSummaryModalDetailsProps {
    addonType: AddonTypeName;
    selectIsLoading: boolean;
    currency?: string;
    selectedAddon?: INoTouchAddon;
    onPurchaseClick: () => void;
}

export const NoTouchPurchaseSummaryModalDetails = ({
    addonType,
    selectIsLoading,
    currency = "USD",
    selectedAddon,
    onPurchaseClick,
}: INoTouchPurchaseSummaryModalDetailsProps) => {
    const { translate } = useTranslate();

    const { isMonthly, isLoading, vatPercent, purchaseDetails } = useNoTouchPurchaseSummaryModalDetails({
        swSettings,
        selectedAddon,
    });

    return (
        <>
            <OrderSummary
                selectIsLoading={selectIsLoading}
                isMonthly={isMonthly}
                isLoading={isLoading}
                addonType={addonType}
                currency={currency}
                vatPercent={vatPercent}
                selectedAddon={selectedAddon}
                purchaseDetails={purchaseDetails}
            />

            <Divider />

            {selectIsLoading ? (
                <Flex
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="space-between"
                    height="100%"
                    width="100%"
                >
                    <PixelPlaceholderLoader
                        width={222}
                        height={22}
                    />

                    <Flex
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="space-between"
                        width="100%"
                        gap="16px"
                    >
                        <PixelPlaceholderLoader
                            width={222}
                            height={22}
                        />

                        <PixelPlaceholderLoader
                            width={222}
                            height={22}
                        />
                    </Flex>
                </Flex>
            ) : (
                <>
                    <Text
                        fontVariant="caption"
                        color={colorsPalettes.carbon[300]}
                        width={"100%"}
                    >
                        {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.details.details.paymentMemo)}
                    </Text>

                    <Footer
                        isLoading={isLoading}
                        selectedAddon={selectedAddon}
                        onPurchaseClick={onPurchaseClick}
                    />
                </>
            )}
        </>
    );
};
